import React, { useRef } from "react";
import classes from "./FitnessPreview.module.scss";
import useScrollOnDrag from "react-scroll-ondrag";
import iphone_empty from "./assets/iphone_empty.svg"
import StatusBar from "./StatusBar/StatusBarSvg"
import TopNavbar from "./TopNavBar/TopNavbar"

export default function MobilePreview({ children }) {
    const containerRef = useRef(null);
    const { events } = useScrollOnDrag(containerRef);

    return (
        <div className={classes.MobilePreviewContainer}
            style={{ background: `url(${iphone_empty})` }}>
            <StatusBar />
            <TopNavbar />
            <div className={classes.MobilePreviewBody} {...events} ref={containerRef}>
                {children}
            </div>
        </div>
    )
}